import Footer from "./Footer"
import SEO from "./SEO"
import { trackOutboundLink, trackProductSelection } from "./analytics"

const collectionItems = [
  {
    name: "Century Blend",
    href: "https://oceanbeachbrands.myshopify.com/products/century-blend-20yr",
    imageSrc: require("./pictures/century-blend-optimized.png"),
    imageAlt: "Zeronimo Century Blend",
  },
  {
    name: "Leonis Blend",
    href: "https://oceanbeachbrands.myshopify.com/products/leonis-blend",
    imageSrc: require("./pictures/leonis-blend-optimized.png"),
    imageAlt: "Zeronimo Leonis Blend",
  },
  {
    name: "Zweigelt",
    href: "https://oceanbeachbrands.myshopify.com/products/zweigelt-red",
    imageSrc: require("./pictures/zweigelt-optimized.png"),
    imageAlt: "Zeronimo Zweigelt",
  },
  {
    name: "Grüner Veltliner",
    href: "https://oceanbeachbrands.myshopify.com/products/gruner-veltliner",
    imageSrc: require("./pictures/gruner-optimized.png"),
    imageAlt: "Zeronimo Grüner Veltliner",
  },
  {
    name: "Sparkling Select",
    href: "https://oceanbeachbrands.myshopify.com/products/sparkling-select",
    imageSrc: require("./pictures/sparkling-select-optimized.png"),
    imageAlt: "Zeronimo Sparkling Select",
  },
];

export default function AboutUs () {
    const trackCollectionClick = (item) => {
      trackProductSelection({
        id: item.name.toLowerCase().replace(/\s+/g, "-"),
        name: `Zeronimo ${item.name}`,
      });
      trackOutboundLink(item.href, item.name, { ecommerce_action: "about_collection_click" });
    };

    return (
        <>
 <SEO
   title="About Ocean Beach Brands | Best Non-Alcoholic Wine Search"
   description="Ocean Beach Brands was founded by Joshua James of Ocean Beach Cafe after years of tasting and sourcing the best non-alcoholic wines, including Zeronimo's 98-point Austrian blends."
   canonical="https://oceanbeachbrands.com/aboutus"
 />
 <div className="bg-black px-5 lg:px-20 py-16 min-h-screen">
    <div className="max-w-6xl static mx-auto">
    <section aria-labelledby="features-heading" className="relative min-h-[600px] lg:min-h-[800px]">
      <div className="aspect-h-2 aspect-w-3 overflow-hidden sm:aspect-w-5 lg:aspect-none lg:absolute lg:h-full lg:w-1/2 lg:pr-4 xl:pr-16 pt-7">
        <div className="relative w-full h-full">
          <img
            src={require("./pictures/zeronimo-looking-up-optimized.jpg")}
            alt="Zeronimo wines displayed elegantly"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent"></div>
        </div>
      </div>

      <div className="mx-auto max-w-2xl md:px-4 sm:px-2 lg:grid lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8 py-8 lg:py-16">
        <div className="md:col-start-2 relative z-10">
          <br className="md:hidden"></br>
          <p className="mt-4 text-gray-200 didact-gothic-regular text-lg leading-relaxed">
            I founded Ocean Beach Cafe in San Francisco to be one of the first dedicated non alcoholic bars and bottle shops in the country. From the beginning, the mission has been clear: find the BEST non alcoholic beverages (especially wine) and share them with others.
          </p>
          <p className="mt-6 text-gray-200 didact-gothic-regular text-lg leading-relaxed">
            For more than five years, I actively searched for the best non alcoholic red wine, specifically, in the world. That search was informed by decades of experience managing wine bars, attending hundreds of tastings, and working alongside sommeliers, wine shop owners, and bartenders who LOVE wine.
          </p>
          <p className="mt-6 text-gray-200 didact-gothic-regular text-lg leading-relaxed">
            The elusive NA Red Wine search ended the moment I opened a bottle of Leonis Blend.
          </p>
          <p className="mt-6 text-gray-200 didact-gothic-regular text-lg leading-relaxed italic font-semibold">
            Massive aromatics, old world funk, structure, tannin, oak, and a long finish.
          </p>
          <p className="mt-6 text-gray-200 didact-gothic-regular text-lg leading-relaxed">
            Since then, we've served Zeronimo wines to more than 2,500 customers, earning consistent rave reviews. We regularly pour it for sommeliers, retailers, and hospitality professionals throughout wine country, and the response is always the same:
          </p>
          <p className="mt-6 text-gray-300 didact-gothic-regular text-xl leading-relaxed italic font-bold">
            "This is the best non alcoholic red wine I've tasted."
          </p>
          <p className="mt-8 text-gray-400 didact-gothic-regular text-base">
            Joshua James - Ocean Beach Cafe, SF's NA Bar + Bottle Shop, est. 2020
          </p>
        </div>
      </div>
    </section>

    {/* Wine Bottles Section */}
    <section className="border-t border-gray-900 mt-16 pt-16 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h3 className="text-2xl font-black text-center text-gray-200 mb-12 uppercase tracking-widest">
          Our Collection
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12 items-end justify-items-center">
          {collectionItems.map((item) => (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackCollectionClick(item)}
              className="group flex flex-col items-center transition-transform hover:scale-105 duration-300"
            >
              <div className="relative w-full max-w-[180px]">
                <img
                  src={item.imageSrc}
                  alt={item.imageAlt}
                  className="w-full h-auto object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.6)]"
                  loading="lazy"
                />
              </div>
              <p className="mt-4 text-sm text-gray-400 text-center font-semibold group-hover:text-yellow-500 transition-colors">
                {item.name}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>

    </div>
  </div>
        <Footer />

        </>
    )
}
